/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

module.exports = {
    $node: document.getElementById('equalizer'),
    slideIndex: 0,
    timer: null,
    active: false,
    show: function () {
        var self = this;

        clearTimeout(this.timeout);

        this.active = true;
        this.$node.style.display = 'block';
        this.$node.children[this.slideIndex].style.display = 'block';
        this.timeout = setTimeout(function animate () {
            self.$node.children[self.slideIndex].style.display = 'none';
            if ( self.slideIndex < 3 ) {
                self.slideIndex++;
            } else {
                self.slideIndex = 0;
            }
            self.$node.children[self.slideIndex].style.display = 'block';
            self.timeout = setTimeout(animate, 85);
        }, 85);
    },
    hide: function () {
        clearTimeout(this.timeout);
        this.$node.style.display = 'none';
        this.$node.children[this.slideIndex].style.display = 'none';
        this.active = false;
    },
    pause: function () {
        clearTimeout(this.timeout);
    }
};
